import React from 'react'
import styles from '../Mainpage/Mainpage.module.css'
import {Link} from 'react-router-dom'

const Dashboard = () =>{
return(
    <>
      <div className="row">
        <div className="navbar-fixed">
          <nav className="nav-wrapper white">
            <div className="container center">
            <Link to='/' className="brand-logo" className={styles.logo}><img src='/img/image.tj9vk9'  alt='logo' /></Link>
            </div>
        </nav>
        </div>
      </div>
    
      <div className="row">
        <div className ="container">
          <div className="col s4 m4">
            <div className={"card",styles.card}>
              <div className="card-image">
                <Link to='/pathfind'>
                  <img src="/img/Pathfinding.png"/>
                </Link>
                <div className="card-content">
                <span className="card-title">PathFinding</span>
                </div>
              </div>
            </div>
          </div>
  
          <div className="col s4 m4">
            <div className={"card",styles.card}>
              <div className="card-image">
                <Link to='/sort'>
                  <img src="/img/sorting.jpeg"/>
                </Link>
                <span className="card-title">Sorting</span>
              </div>
            </div>
          </div>
  
          <div className="col s4 m4">
            <div className={"card",styles.card}>
              <div className="card-image">
                <Link to='/search'>
                  <img src="/img/searching.jpeg"/>
                </Link>
                <span className="card-title">Searching</span>
              </div>
            </div>
          </div>
      </div>
    </div>
  </>
)
}
export default Dashboard;